import axios from "axios";
import qs from "querystring";
import { isTrue } from "../Utils/filter";

/**
 * 用指定大小的矩阵填充二维数组
 */
export function tableFill<T>(
    data: T[][],
    { rows, columns, fill }: { rows: number; columns: number; fill: T }
): T[][] {
    const data2: T[][] = [];

    for (let x = 0; x < rows; x++) {
        if (!data[x]) {
            data2[x] = new Array(columns).fill(fill);
            continue;
        }

        if (!data2[x]) {
            data2[x] = [];
        }

        for (let y = 0; y < columns; y++) {
            data2[x][y] = data[x][y] || fill;
        }
    }

    return data2;
}

/**
 * 二维数组行列互换
 */
export function tableTranspose<T>(data: T[][]) {
    let newTable: T[][] = [];
    if (!data[0]) return newTable;

    for (let x = 0; x < data[0].length; x++) {
        newTable[x] = [];

        for (let y = 0; y < data.length; y++) {
            newTable[x][y] = data[y][x];
        }
    }

    return newTable;
}

interface TermListItem {
    batchName: string; //学期名称
    batchNo: string; //学期编号
    beginDate: string;
    customerCode: string;
    dayOfWeek: number;
    endDate: string;
    id: string;
    isCurrentTerm: BooleanValue; //是否当前学期
    weekNo: number;
}

/**
 * 获取学期列表
 */

export function getTermList() {
    return axios
        .get<SuccessData<TermListItem[]>>("/student/term/getTermList")
        .then(res => res.data.data)
        .then(data => {
            const defaultBatch = data?.find((item: TermListItem) =>
                isTrue(item.isCurrentTerm)
            )?.batchNo;
            localStorage.setItem("batch", defaultBatch!);
            return data?.slice(-3);
        });
}

export interface CoursePlanWeek {
    weekTime: string;
    week: string;
    section: string;
    continunity: string;
    weekTimeId: string;
}

/**
 * 当日课程关闭直播（备课直播滑块关）
 */
export function getCoursePlanWeek(params: {
    courseNo: string;
    courseSeq: string;
}) {
    return axios
        .get<SuccessData<CoursePlanWeek[]>>(
            `/student/getCoursePlanWeek?${qs.stringify(params)}`
        )
        .then(res => res.data.data);
}
